const HOME = {
    title: 'Intro',
    in: [0, 104],
    labelIn: 20,
    infocardIn: 30
  }

export default HOME